import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const LearningDifferenciesContext = React.createContext();

export const useLearningDifferenciesContext = () => useContext(LearningDifferenciesContext);

export function LearningDifferenciesProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/284bae09-22ae-4a92-95ed-af545784b22f').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/cdccca87-1b8c-413e-97e1-08ba3db0b78c')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return (
    <LearningDifferenciesContext.Provider value={value}>
      {children}
    </LearningDifferenciesContext.Provider>
  );
}
